<template>
  <div>
    <div class>
      <div
        v-for="(item,index) in matchList"
        :key="index"
        class="myregister"
        @click="bindClick(item)"
      >
        <div>{{item.title}}</div>
        <div>
          <img :src="item.imgurl" />
          <div class="content">
            <div>
              <div>举办时间:</div>
              <div style="color:#666;">{{item.endtime*1000|moment("YYYY-MM-DD hh:mm")}}</div>
            </div>
            <div>
              <div style="white-space: nowrap;">活动地点:</div>
              <div
                style="color:#666; white-space: nowrap; overflow: hidden;  text-overflow: ellipsis;"
              >{{item.address}}</div>
            </div>
          </div>
        </div>
        <div style="font-size: 14px;float: right;">
          <Tag
            :type="formtite(item.state,item.ischeck,item.statetips).type"
          >{{formtite(item.state,item.ischeck,item.statetips).tips}}</Tag>
          <div>订单时间:{{item.ordertime*1000|moment("YYYY-MM-DD")}}</div>
        </div>
      </div>
      <infinite-loading @infinite="infiniteHandler">
        <div class="no-result" slot="spinner">拼命加载中...</div>
        <div class="no-result" slot="no-more">暂无更多数据</div>
        <div slot="no-results">
          <span class="no-result">—— 暂无数据 ——</span>
        </div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import "./myregister.less";
import { mymatchindex } from "@/libs/api";
import { Divider, Tag } from "vant";
import { getStorage } from "@/libs/utils";

export default {
  name: "myregiter",
  components: {
    Divider,
    Tag
  },
  data() {
    return {
      page: 1,
      matchList: []
    };
  },
  methods: {
    infiniteHandler: function($state) {
      // this.handleSpinShow(true);
      let userinfo = getStorage("userInfo");
      let urid = userinfo.urid;
      let token = userinfo.token;
      mymatchindex({ page: this.page, urid: urid, token: token }).then(res => {
        if (res.status == 200) {
          if (res.data.list.length > 0) {
            this.page += 1;
            this.matchList.push(...res.data.list);
            $state.loaded();
            if (res.data.list.length < 20) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        }
        // this.handleSpinShow(false);
      });
    },
    formtite(state, ischeck, statetips) {
      if (ischeck == 1) {
        switch (state * 1) {
          case 1:
            return { tips: "报名成功", type: "success" };
          case 2:
            return { tips: "待支付", type: "primary" };
          case 3:
            return { tips: "待支付", type: "danger" };
          case 101:
            return { tips: "订单超时", type: "danger" };
          default:
            return { tips: "待支付", type: "danger" };
        }
      } else {
        return { tips: "待审核", type: "primary" };
      }
    },
    bindClick(item) {
      if (item.type == 3) {
        this.$router.push({ name: "manage", params: item });
      } else {
        this.$router.push({ name: "orderview", params: item });
      }
    }
  },
  mounted() {
    this.$nextTick(() => {});
  }
};
</script>

<style >
.no-result {
  font-size: 14px;
  color: #999;
  padding: 20px 0;
  display: block;
}
</style>